import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { ContextHeadline } from '@aok/text-elements'
import { ArrowRoundedRight } from '@aok/icon-functional'

import defaultProps from '../../../utils/propTypes/defaultProps'

import { getHeadlineText } from '../../../utils/TextUtils'
import { ColorScheme } from '../../../utils/defaultTypes'

const LinkHeadline = ({ headline, headlineClassName, className, theme }) => {
  const textClasses = classnames({
    'text-005e3f': theme !== ColorScheme.DARK,
    'text-ffffff': theme === ColorScheme.DARK,
    'group-hover:text-18ab42 focus:text-18ab42': theme !== ColorScheme.DARK && headline.url,
    'group-hover:text-50eb5d focus:text-50eb5d': theme === ColorScheme.DARK && headline.url,
    'hyphens': /&shy/g.test(headline.text) === false,
  })

  const placeholderClasses = classnames({
    'text-005e3f': theme !== ColorScheme.DARK,
    'text-50eb5d': theme === ColorScheme.DARK,
  })

  let headlineText = null
  if (headline.url) {
    headlineText = (
      <a href={headline.url} className={`block ${textClasses}`}>
        <span dangerouslySetInnerHTML={{ __html: getHeadlineText(headline, placeholderClasses) }} />
        <ArrowRoundedRight className="inline fill-current ml-16 w-24 h-24 transition-transform ease-in-out duration-350 group-hover:scale-120" />
      </a>
    )
  } else {
    headlineText = (
      <span
        className={textClasses}
        dangerouslySetInnerHTML={{ __html: getHeadlineText(headline, placeholderClasses) }}
      />
    )
  }

  return (
    <div
      className={`
        linkHeadline
        w-full
        1280:mx-auto 1280:max-w-1216
        ${className}
      `}
    >
      <ContextHeadline className={`font-buenos-aires font-semibold group ${headlineClassName}`}>
        {headlineText}
      </ContextHeadline>
    </div>
  )
}

LinkHeadline.propTypes = {
  headline: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
  }),
  headlineClassName: PropTypes.string,
  className: PropTypes.string,
  theme: PropTypes.oneOf([ColorScheme.LIGHT, ColorScheme.DARK]),
}

LinkHeadline.defaultProps = {
  headline: {
    text: defaultProps.HEADLINE,
    url: defaultProps.URL,
  },
  headlineClassName: 'text-28 leading-36 1280:text-32 1280:leading-44', // default
  className: '',
  theme: ColorScheme.LIGHT,
}

export default LinkHeadline
